export default {
  MINIMUM_RATE: 0.1,

  BALANCE_MINIMUM: 100,
  MONTHLY_MINIMUM: 100,

  CAMPAIGN_NAME_MAX_LENGTH: 128,
  CAMPAIGN_MAX_LIMIT: 10000000,

  RETARGETING_DAILY_LIMIT: 10,
  RETARGETING_MONTHLY_LIMIT: 100,
  RETARGETING_MINIMUM_EXPECTED_COS: 10,
  RETARGETING_MAXIMUM_EXPECTED_COS: 100,

  RETARGETING_MINIMUM_EXPECTED_ROAS: {
    D2: 100,
    D7: 100,
    D14: 100,
    D30: 100,
    LAST_CLICK: 100,
    LAST_CLICK_1D: 100,
  },
  RETARGETING_MAXIMUM_EXPECTED_ROAS: {
    D2: 10000,
    D7: 10000,
    D14: 10000,
    D30: 10000,
    LAST_CLICK: 3333,
    LAST_CLICK_1D: 3333,
  },

  DYNAMIC_CPSC_MINIMUM_RATE: 2.5,
  DYNAMIC_CPSC_MAXIMUM_RATE: 1000000,
  DYNAMIC_CPSC_MONTHLY_LIMIT: 100,
  DYNAMIC_CPSC_DAILY_LIMIT: 10,

  MAILING_MIN_BUDGET: 100,
  MAILING_DAILY_LIMIT: 10,
  MAILING_MINIMUM_RATE: 2,
  MAILING_MAXIMUM_RATE: 50,
  MAILING_FROM_MAX_LENGTH: 256,
  MAILING_TO_MAX_LENGTH: 256,

  MAILING_CPM_MIN_BUDGET: 100,
  MAILING_CPM_DAILY_LIMIT: 10,
  MAILING_CPM_MINIMUM_RATE: 20,
  MAILING_CPM_MAXIMUM_RATE: 50,

  MAILING_RETARGETING_MAXIMUM_RATE: 20,

  PROSPECTING_MAXIMUM_RATE: 9.99,
  PROSPECTING_MINIMUM_RATE: 1,
  PROSPECTING_BUDGET_DAILY_MIN_LIMIT: 1,
  PROSPECTING_BUDGET_DAILY_MAX_LIMIT: 1000000,
  PROSPECTING_BUDGET_MIN_LIMIT: 1,
  PROSPECTING_BUDGET_MAX_LIMIT: 1000000,
  PROSPECTING_DESKTOP_RATE_LIMIT: 0.5,
  PROSPECTING_MOBILE_RATE_LIMIT: 0.3,

  MAILING_PROSPECTING_MINIMUM_RATE: 2,

  DISPLAY_MIN_BUDGET: 1,
  DISPLAY_MAX_BUDGET: 1000000,
  DISPLAY_MIN_DAILY_BUDGET: 1,
  DISPLAY_MAX_DAILY_BUDGET: 1000000,
  DISPLAY_DESKTOP_MIN_RATE: 0.5,
  DISPLAY_MOBILE_MIN_RATE: 0.3,
  MAX_RATE: 9.99,

  DISPLAY_CPM_DESKTOP_RATE_LIMIT: 1,
  DISPLAY_CPM_MOBILE_RATE_LIMIT: 1,
  DISPLAY_CPM_BUDGET_DAILY_MIN_LIMIT: 1,
  DISPLAY_CPM_BUDGET_DAILY_MAX_LIMIT: 1000000,
  DISPLAY_CPM_BUDGET_MIN_LIMIT: 1,
  DISPLAY_CPM_BUDGET_MAX_LIMIT: 1000000,

  DISPLAY_VCPM_MIN_RATE: 2,
  DISPLAY_VCPM_MIN_DAILY_BUDGET_IN_VIMP: 1,
  DISPLAY_VCPM_MIN_BUDGET_IN_VIMP: 1000,

  DISPLAY_CPM_MIN_RATE: 2,
  DISPLAY_CPM_MIN_DAILY_BUDGET_IN_IMP: 1,
  DISPLAY_CPM_MIN_BUDGET_IN_IMP: 1000,

  MAIL_FROM_MAX_LENGTH: 256,
  REPLY_TO_MAX_LENGTH: 256,

  PROSPECTING_MONTHLY_LIMIT: 100,
  PROSPECTING_MIN_DAILY_LIMIT: 10,
  PROSPECTING_MAX_DAILY_LIMIT: 1000000,

  NATIVE_LINK_DIRECT_GLOBAL_LIMIT: 100,
  NATIVE_LINK_DIRECT_DAILY_LIMIT: 10,
  NATIVE_LINK_DIRECT_RATE: 1,

  NATIVE_SG_GLOBAL_LIMIT: 100,
  NATIVE_SG_DAILY_LIMIT: 10,
  NATIVE_SG_RATE_LIMIT: 0.8,

  START_PAUSE_AD_RATE: 6,
  START_PAUSE_AD_GLOBAL_LIMIT: 1000,
  START_PAUSE_AD_DAILY_LIMIT: 50,
}
